<section class="mt-2 mb-1">
	<h5 class="font-weight-bold">
		<svg-frontends-string-or-template-ref [value]="label"></svg-frontends-string-or-template-ref>
	</h5>
	<ng-content></ng-content>
</section>
